/* eslint-disable radix */

import { generateRandomString } from 'utils/helpers';
import { AccountingType } from 'v2-types/order';

const generateGenericAccounting = (size:number, startNumber:number, letter:string) :AccountingType[] => Array.from(Array(size).keys()).map((_, index) => ({
  _id: generateRandomString(10),
  amount: 0,
  amount_calculated: 0,
  amount_override: 0,
  code: 'charge',
  kind: 'manual',
  letter,
  number: startNumber + index,
  description: '',
  involved_parties: [],
  entry_date: '',
  months: null,
  per_month: null,
}));

const fillCharges = (acc:AccountingType[], from:number, to:number, size:number, letter:string) => {
  const filteredAccounting = acc?.filter((a) => a.letter?.includes(letter));
  const numbersToInclude = Array.from({ length: (to - from) / 1 }, (value, index) => from + index * 1);
  const filteredCharges = filteredAccounting.filter((f) => numbersToInclude.some((s) => parseInt(f.number as unknown as string) === s));
  if (filteredCharges.length < size) {
    return [
      ...generateGenericAccounting(size, from, letter).map((genericChharge) => {
        const findedCharge = filteredCharges.find((charge) => parseInt(charge.number as unknown as string) === genericChharge.number);
        if (findedCharge) {
          return findedCharge;
        }
        return genericChharge;
	  })
    ];
  }
  return filteredCharges;
};
export const formatDataKM = (accountingData: AccountingType[]) => accountingData.map((f) => ({
  id: f._id,
  description: f.description,
  chargeData: f,
  number: f.number
}));

export const mockData = (accounting:AccountingType[]) => ({
  grossAmountBorrower: formatDataKM(fillCharges(accounting, 101, 105, 5, 'J')),
  grossAmountSeller: formatDataKM(fillCharges(accounting, 401, 405, 5, 'K')),
  JAdjustmentsItems: formatDataKM(fillCharges(accounting, 106, 113, 7, 'J')),
  KAdjustments: formatDataKM(fillCharges(accounting, 406, 413, 7, 'K')),

  JGrosstotals: formatDataKM(fillCharges(accounting, 120, 121, 1, 'J')),
  KGrosstotals: formatDataKM(fillCharges(accounting, 420, 421, 1, 'K')),

  JAdjustmentsItemssecond: formatDataKM(fillCharges(accounting, 201, 209, 9, 'J')),
  KAdjustmentssecond: formatDataKM(fillCharges(accounting, 501, 509, 9, 'K')),

  JUnpaidItems: formatDataKM(fillCharges(accounting, 210, 220, 10, 'J')),
  KUnpaidItems: formatDataKM(fillCharges(accounting, 510, 520, 10, 'K')),

  JUnpaidTotals: formatDataKM(fillCharges(accounting, 220, 221, 1, 'J')),
  KUnpaidTotals: formatDataKM(fillCharges(accounting, 520, 521, 1, 'K')),

  CashBorrower: formatDataKM(fillCharges(accounting, 301, 304, 3, 'J')),
  CaskSeller: formatDataKM(fillCharges(accounting, 601, 604, 3, 'K')),
});
